<template>
	<IntNavButton color="tint" full-border bold-text @click="onAddToBasketClick">
		<slot></slot>
	</IntNavButton>
</template>

<script>
import { mapActions, mapStores } from "pinia"
import { useBasketStore } from "../../../../stores/basket"
import AddToBasket from "../../models/AddToBasket"
import BasketProductQuantity from "../../models/BasketProductQuantity"

import IntNavButton from "../../../nav-button/"

export default {
	name: "IntBasketButton",

	emits: ["basket-updated"],

	components: { IntNavButton },

	props: {
		postUrl: {
			type: String,
			required: true,
		},
		productId: {
			type: Number,
			required: true,
		},
		productReference: {
			type: String,
			required: true,
		},
		quantity: {
			type: Number,
			default: 1,
			validator: (value) => {
				return value !== null && value !== undefined && value !== "" && value > 0
			},
		},
	},

	computed: {
		...mapStores(useBasketStore),
	},

	methods: {
		...mapActions(useBasketStore, ["add"]),

		onAddToBasketClick() {
			const basketPostDto = new AddToBasket(
				this.productId,
				this.productReference,
				this.quantity,
			)

			// Fetch anti-forgery token from the document
			const requestVerificationToken = document.querySelector(
				'input[name="__RequestVerificationToken"]',
			).value

			fetch(this.postUrl, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					RequestVerificationToken: requestVerificationToken,
				},
				body: JSON.stringify(basketPostDto),
			})
				.then((response) => {
					if (!response.ok) {
						response.json().then((data) => {
							const errorMessage = data.error

							this.$emit("basket-updated", errorMessage)

							throw new Error(errorMessage)
						})
					} else {
						// Update Pinia store and display product data in basket popup
						const basketProductQuantity = new BasketProductQuantity(
							this.productId,
							this.quantity,
						)
						this.basketStore.add(basketProductQuantity)

						this.$emit("basket-updated")
					}
				})
				.catch((error) => {
					this.$emit("basket-updated", error)

					throw new Error(error)
				})
		},
	},
}
</script>
